var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OMNI_STRINGS } from '../omnidashboard.config';
import { resolveOmniFilters } from '../filters/omnidashboard-filters';
import { buildMatrixCellMap, buildMatrixGrid, buildResolvedGrid, buildSummary, buildVisibleRows, countVisibleChapters, deriveAxesFromChapters, } from './omnidashboard-matrix';
import { formatDefaultCellTooltip, getMetricDefinitionOrThrow, } from '../metrics/metric-registry';
export function createEmptyMatrixViewModel() {
    return {
        siteColumns: [],
        ergRows: [],
        visibleSiteColumns: [],
        visibleErgRows: [],
        visibleRows: [],
        visibleChapterCount: 0,
        summary: [],
        matrixCellMap: new Map(),
        matrixGrid: [],
        resolvedGrid: [],
    };
}
function getCellTooltip(cell, activeView, activeMetric) {
    if (activeMetric === void 0) { activeMetric = getMetricDefinitionOrThrow(activeView); }
    if (!cell.chapterId) {
        return OMNI_STRINGS.cellNaTooltip;
    }
    var metric = cell.metrics.get(activeMetric.key) || activeMetric.naMetric;
    if (activeMetric.tooltipFormatter) {
        return activeMetric.tooltipFormatter(cell, metric);
    }
    return formatDefaultCellTooltip(cell);
}
export function buildMatrixFromChapters(chapters) {
    var axes = deriveAxesFromChapters(chapters);
    var matrixCellMap = buildMatrixCellMap(chapters);
    var matrixGrid = buildMatrixGrid(axes.ergRows, axes.siteColumns, matrixCellMap);
    return {
        siteColumns: axes.siteColumns,
        ergRows: axes.ergRows,
        matrixCellMap: matrixCellMap,
        matrixGrid: matrixGrid,
    };
}
export function buildMatrixViewModel(activeView, filters, siteColumns, ergRows, matrixCellMap, matrixGrid) {
    var activeMetric = getMetricDefinitionOrThrow(activeView);
    var tooltipResolver = function (cell) { return getCellTooltip(cell, activeView, activeMetric); };
    var resolvedGrid = buildResolvedGrid(matrixGrid, activeMetric, tooltipResolver);
    var resolvedFilters = resolveOmniFilters(filters, siteColumns, ergRows, 0);
    var visibleRows = buildVisibleRows(ergRows, siteColumns, resolvedFilters.visibleErgRows, resolvedFilters.visibleSiteColumns, matrixGrid, resolvedGrid, matrixCellMap, activeMetric, tooltipResolver);
    var visibleChapterCount = countVisibleChapters(visibleRows);
    var summary = resolvedFilters.hasNoVisibleMatrix
        ? []
        : buildSummary(activeMetric, visibleRows, resolvedFilters.visibleErgRows, resolvedFilters.visibleSiteColumns);
    return {
        siteColumns: siteColumns,
        ergRows: ergRows,
        visibleSiteColumns: resolvedFilters.visibleSiteColumns,
        visibleErgRows: resolvedFilters.visibleErgRows,
        visibleRows: visibleRows,
        visibleChapterCount: visibleChapterCount,
        summary: summary,
        matrixCellMap: matrixCellMap,
        matrixGrid: matrixGrid,
        resolvedGrid: resolvedGrid,
    };
}
export function applyMetricToAllCells(matrixCellMap, metricName, resolver) {
    // Returns new map/cell references so OnPush consumers detect the update.
    var next = new Map();
    matrixCellMap.forEach(function (cell, key) {
        var metrics = new Map(cell.metrics);
        metrics.set(metricName, resolver(cell));
        next.set(key, __assign({}, cell, { metrics: metrics }));
    });
    return next;
}
